
const notificationTypes = {
    setNewNotificationList: 'SET_NEW_NOTIFICATION_LIST',
    readNotification: 'READ_NOTIFICATION',
    readAllNotification: 'READ_ALL_NOTIFICATION',
    loadNotification: 'LOAD_NOTIFICATION',
    errorNotification: 'ERROR_NOTIFICATION',
};

export default notificationTypes;